// extracted by mini-css-extract-plugin
module.exports = {"module":"drawer_module__2yaYm","widthGrow":"drawer_widthGrow__70fFG","close":"drawer_close__cv36U","content":"drawer_content__3FnE4"};